// Registro de controladores Stimulus del bundle base.
// Al agregar un controlador nuevo hay que importarlo y registrarlo aquí.
// Los que dependen de librerías pesadas (rich-text, chart) se registran desde
// sus propios bundles: app/javascript/editor.js y app/javascript/charts.js.
import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
import AutoguardadoController from "./autoguardado_controller"
import AvisoDiferidoController from "./aviso_diferido_controller"
import AvisosController from "./avisos_controller"
import ClasesUnidadController from "./clases_unidad_controller"
import ComboboxController from "./combobox_controller"
import ConditionalFieldsController from "./conditional_fields_controller"
import DependentSelectController from "./dependent_select_controller"
import IndicePasosController from "./indice_pasos_controller"
import LateralFijoController from "./lateral_fijo_controller"
import SegunFormatoController from "./segun_formato_controller"
import DialogController from "./dialog_controller"
import FormatoIaController from "./formato_ia_controller"
import DisclosureController from "./disclosure_controller"
import DropdownController from "./dropdown_controller"
import FileFieldController from "./file_field_controller"
import FiltroTemasController from "./filtro_temas_controller"
import FlashController from "./flash_controller"
import MegaMenuController from "./mega_menu_controller"
import MobileMenuController from "./mobile_menu_controller"
import NestedFormController from "./nested_form_controller"
import OrderedListController from "./ordered_list_controller"
import ProfileCardController from "./profile_card_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import RequiereTextoController from "./requiere_texto_controller"
import SearchBarController from "./search_bar_controller"
import TagInputController from "./tag_input_controller"
import TurnstileController from "./turnstile_controller"

application.register("auto-submit", AutoSubmitController)
application.register("autoguardado", AutoguardadoController)
application.register("aviso-diferido", AvisoDiferidoController)
application.register("avisos", AvisosController)
application.register("clases-unidad", ClasesUnidadController)
application.register("combobox", ComboboxController)
application.register("conditional-fields", ConditionalFieldsController)
application.register("dependent-select", DependentSelectController)
application.register("indice-pasos", IndicePasosController)
application.register("lateral-fijo", LateralFijoController)
application.register("segun-formato", SegunFormatoController)
application.register("dialog", DialogController)
application.register("formato-ia", FormatoIaController)
application.register("disclosure", DisclosureController)
application.register("dropdown", DropdownController)
application.register("file-field", FileFieldController)
application.register("filtro-temas", FiltroTemasController)
application.register("flash", FlashController)
application.register("mega-menu", MegaMenuController)
application.register("mobile-menu", MobileMenuController)
application.register("nested-form", NestedFormController)
application.register("ordered-list", OrderedListController)
application.register("profile-card", ProfileCardController)
application.register("password-visibility", PasswordVisibilityController)
application.register("requiere-texto", RequiereTextoController)
application.register("search-bar", SearchBarController)
application.register("tag-input", TagInputController)
application.register("turnstile", TurnstileController)
